import { ThreadActionsFooter } from './ThreadActionsFooter';
import { ThreadCollapsedIndicator } from './ThreadCollapsedIndicator';
import { ThreadRepliesContainer } from './ThreadRepliesContainer';
import { ThreadReplyAuthor } from './ThreadReplyAuthor';
import { ThreadReplyButton } from './ThreadReplyButton';
import { ThreadReplyInput } from './ThreadReplyInput';
import { ThreadReplyInputConnector } from './ThreadReplyInputConnector';
import { ThreadReplyList } from './ThreadReplyList';
import { ThreadReplyRailDecorations } from './ThreadReplyRailDecorations';
import { ThreadRow } from './ThreadRow';

export const Thread = {
  Row: ThreadRow,
  ReplyRailDecorations: ThreadReplyRailDecorations,
  RepliesContainer: ThreadRepliesContainer,
  ReplyButton: ThreadReplyButton,
  ReplyList: ThreadReplyList,
  CollapsedIndicator: ThreadCollapsedIndicator,
  ReplyInputConnector: ThreadReplyInputConnector,
  ReplyAuthor: ThreadReplyAuthor,
  ReplyInput: ThreadReplyInput,
  ActionsFooter: ThreadActionsFooter,
};
